/**
 * Extracts the customuser_id value from a string in the format "account_id:2074697,customuser_id:567871"
 * @param input - The formatted string containing account_id and customuser_id
 * @returns The customuser_id as a number, or undefined if it cannot be extracted or isn't a valid number
 */
export function extractCustomuserId(input: string): number | undefined {
  if (!input || typeof input !== "string") {
    return undefined;
  }

  // Use regex to find customuser_id followed by a colon and digits
  const match = input.match(/customuser_id:(\d+)/);

  if (!match || !match[1]) {
    return undefined;
  }

  const parsed = Number(match[1]);

  // Check if the parsed value is a valid number (not NaN)
  if (Number.isNaN(parsed)) {
    return undefined;
  }

  return parsed;
}
